import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js'
import { Bar, Line } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

interface LineChartProps {
  data: {
    labels: string[]
    datasets: {
      label: string
      data: number[]
      borderColor: string
      backgroundColor: string
    }[]
  }
}

export function LineChart({ data }: LineChartProps) {
  return (
    <Line
      data={data}
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: 'top' as const
          }
        }
      }}
    />
  )
}

interface BarChartProps {
  data: {
    workspace: string
    rate: number
  }[]
}

export function BarChart({ data }: BarChartProps) {
  const chartData = {
    labels: data.map((d) => d.workspace),
    datasets: [
      {
        label: 'Success Rate (%)',
        data: data.map((d) => d.rate),
        backgroundColor: 'rgba(53, 162, 235, 0.5)'
      }
    ]
  }

  return (
    <Bar
      data={chartData}
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: 'top' as const
          }
        }
      }}
    />
  )
}
